import { render, staticRenderFns } from "./CorrectManage.vue?vue&type=template&id=6ec87130&scoped=true&"
import script from "./CorrectManage.vue?vue&type=script&lang=js&"
export * from "./CorrectManage.vue?vue&type=script&lang=js&"
import style0 from "./CorrectManage.vue?vue&type=style&index=0&id=6ec87130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec87130",
  null
  
)

export default component.exports